import { AttioRecordMigrationPreview, AttioRecordMigrationStatus } from "src/api-service";

// **************************************************************************
// ATTIO RECORD MIGRATION STATE (companies and contacts from Attio)
// **************************************************************************
export type AttioRecordMigrationKind = "company" | "contact";

export interface AttioRecordMigrationLoadingState {
    loadingPreview: boolean;
    starting: boolean;
}

export interface AttioRecordMigrationSlot {
    preview: AttioRecordMigrationPreview | undefined;
    /** The current or last run; undefined until the API has been asked. */
    status: AttioRecordMigrationStatus | undefined;
    loading: AttioRecordMigrationLoadingState;
}

export type AttioRecordMigrationState = Record<AttioRecordMigrationKind, AttioRecordMigrationSlot>;

const initialSlot: AttioRecordMigrationSlot = {
    preview: undefined,
    status: undefined,
    loading: { loadingPreview: false, starting: false },
};

export const initialAttioRecordMigrationState: AttioRecordMigrationState = {
    company: initialSlot,
    contact: initialSlot,
};
